import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { LayoutSelectorService } from "@m19-board/layout-selector.service";

@Component({
  selector: "app-logo",
  template: `<img [src]="navbarBrandFull.src" [alt]="navbarBrandFull.alt" class="h-full" />`,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent {
  private readonly layoutSelectorService = inject(LayoutSelectorService);

  readonly navbarBrandFull = {
    src: this.layoutSelectorService.getLogo(),
    alt: "logo",
  };
}
